import React from 'react';// jscs:ignore JS045
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
// import Routes from './Routes';
import store from './Store';
import {view as Home} from './Pages/home';

ReactDOM.render(
    <Provider store={store}>
        <Home />
    </Provider>,
    document.getElementById('root')
);




// WEBPACK FOOTER //
// ./src/index.js